import React from "react";
import LineChart from "../components/dashboard/reportChart";
import { Typography } from "antd";
const { Title } = Typography;

const Dashboard = () => {
  return (
    <div>
      <Title level={2} className="text-left pb-4">
        Report
      </Title>
      <LineChart />
    </div>
  );
};

export default Dashboard;
